// Modal : <dialog> natif piloté par [data-modal-open="id"].
// - focus-trap, Esc et restitution du focus sont gérés nativement par showModal().
// - l'iframe du formulaire est chargée à la 1re ouverture (data-src → src) pour la perf.
// - verrouille le scroll de la page (classe sur <html>) et met Lenis en pause via events.
export function initModal() {
  const openers = document.querySelectorAll("[data-modal-open]");
  if (!openers.length || typeof HTMLDialogElement === "undefined") return;

  const lockScroll = (locked) => {
    // Lenis verrouille déjà via .lenis-stopped ; ce fallback couvre le cas sans Lenis
    // (prefers-reduced-motion). modal:open/close met Lenis en pause côté smoothScroll.
    document.body.style.overflow = locked ? "hidden" : "";
    document.dispatchEvent(new CustomEvent(locked ? "modal:open" : "modal:close"));
  };

  const openModal = (dialog) => {
    if (!dialog || dialog.open) return;
    // Chargement paresseux de l'iframe au premier affichage. On révèle l'iframe (qui
    // recouvre alors le loader) une fois son contenu chargé.
    const frame = dialog.querySelector("[data-src]");
    if (frame && !frame.src) {
      frame.addEventListener("load", () => frame.classList.add("c-dialog__frame--loaded"), { once: true });
      frame.src = frame.dataset.src;
    }
    dialog.showModal();
    lockScroll(true);
  };

  openers.forEach((btn) => {
    const dialog = document.getElementById(btn.dataset.modalOpen);
    if (!dialog) return;

    btn.addEventListener("click", () => openModal(dialog));

    // Clic sur le fond (en dehors du panneau) → fermeture.
    dialog.addEventListener("click", (e) => {
      if (e.target === dialog) dialog.close();
    });

    // Bouton de fermeture explicite.
    dialog.querySelector("[data-modal-close]")?.addEventListener("click", () => dialog.close());

    // Restaure le scroll quand le dialog se ferme (clic, Esc, bouton).
    dialog.addEventListener("close", () => lockScroll(false));
  });
}
